var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPancake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54286 3C4.69076 3 4 3.69076 4 4.54286C4 5.39495 4.69076 6.08571 5.54286 6.08571H13V10.5C13 11.3284 13.6716 12 14.5 12C15.3284 12 16 11.3284 16 10.5V6.08571H18.4571C19.3092 6.08571 20 5.39495 20 4.54286C20 3.69076 19.3092 3 18.4571 3H5.54286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.62866H5.54286C4.69076 7.62866 4 8.31942 4 9.17152C4 10.0236 4.69076 10.7144 5.54286 10.7144H11.5075C11.5025 10.6436 11.5 10.5721 11.5 10.5V7.62866Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0682 12.2572C12.6133 13.0102 13.4994 13.5 14.5 13.5C15.5006 13.5 16.3867 13.0102 16.9318 12.2572H18.4571C19.3092 12.2572 20 12.948 20 13.8001C20 14.6522 19.3092 15.3429 18.4571 15.3429H5.54286C4.69076 15.3429 4 14.6522 4 13.8001C4 12.948 4.69076 12.2572 5.54286 12.2572H12.0682Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4925 10.7144C17.4975 10.6436 17.5 10.5721 17.5 10.5V7.62866H18.4571C19.3092 7.62866 20 8.31942 20 9.17152C20 10.0236 19.3092 10.7144 18.4571 10.7144H17.4925Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.8858H22V18.0001C22 19.6569 20.6569 21.0001 19 21.0001H5C3.34315 21.0001 2 19.6569 2 18.0001V16.8858Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancake);
export default __webpack_public_path__ + "static/media/pancake.9f664126731371230aefaca27d90cdff.svg";
export { ForwardRef as ReactComponent };